import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { format, subDays } from 'date-fns';

const BatteryGraph = ({ imei }) => {
    const [rawData, setRawData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    // Initialize From (7 days ago) and To (Now)
    const [fromDate, setFromDate] = useState(format(subDays(new Date(), 7), "yyyy-MM-dd'T'HH:mm"));
    const [toDate, setToDate] = useState(format(new Date(), "yyyy-MM-dd'T'HH:mm"));

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const res = await axios.get(`https://api.teltonika.intelisparkz.com/api/battery-history/?imei=${imei}`);
                setRawData(res.data);
            } catch (err) { console.error("API Error:", err); }
        };
        fetchHistory();
    }, [imei]);

    useEffect(() => {
        if (!rawData.length) return;

        const start = new Date(fromDate).getTime();
        const end = new Date(toDate).getTime();

        const filtered = rawData
            .map(item => ({
                time: new Date(item.timestamp).getTime(),
                voltage: item.battery_level,
            }))
            .filter(d => d.time >= start && d.time <= end)
            .sort((a, b) => a.time - b.time);

        setFilteredData(filtered);
    }, [rawData, fromDate, toDate]);

    return (
        <div className="graph-card-content">
            <div className="graph-controls">
                <span className="graph-title">7-Day Battery Analysis</span>
                <div className="filter-inputs">
                    <label>From: <input type="datetime-local" value={fromDate} onChange={e => setFromDate(e.target.value)} /></label>
                    <label>To: <input type="datetime-local" value={toDate} onChange={e => setToDate(e.target.value)} /></label>
                </div>
            </div>

            <ResponsiveContainer width="100%" height={280}>
                <LineChart data={filteredData}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
                    <XAxis
                        dataKey="time"
                        type="number"
                        domain={['auto', 'auto']}
                        tickFormatter={(t) => format(new Date(t), 'MMM dd HH:mm')}
                        fontSize={10}
                    />
                    <YAxis domain={['dataMin - 50', 'dataMax + 50']} tickFormatter={(v) => `${v}mV`} fontSize={10} />
                    <Tooltip labelFormatter={(t) => format(new Date(t), 'MMM dd, HH:mm:ss')} />
                    <Line type="monotone" dataKey="voltage" stroke="#3498db" strokeWidth={2} dot={false} animationDuration={500} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default BatteryGraph;